"use client";

import React from "react";

export interface CtlOverviewBlockProps {
    tag?: string;
    title?: string;
    sublabel?: string;
    intentionTag?: string;
    intentionText?: string;
    intentionCommit?: string;
    expertiseTag?: string;
    expertiseText?: string;
    expertiseCerts?: string;
    expertiseBrand?: string;
}

export default function CtlOverviewBlock({
    tag = "01 / OVERVIEW",
    title = "Corporate Intentions & Foundations",
    sublabel = "SYSTEM INTENTIONS & HISTORIES",
    intentionTag = "// COLLABORATIVE INTENTIONS",
    intentionText = "We are using technology to transform the world by designing efficiently and responsibly for businesses that want to enhance their customer experience and expand their brand offerings. We meet you halfway with innovation and deliver researched, customised solutions as per your business requirements.",
    intentionCommit = "Commitment: Designing efficiently and responsibly",
    expertiseTag = "// COMPREHENSIVE EXPERTISE",
    expertiseText = "CTL instituted in 1994, is an ISO 9001 -2015 Certified Organisation. With initial operations in the telecom industry for MTNL in Mumbai, it made its foray into the Information Technology segment. Since 2004, CTL has successfully rendered influential collaborations for Data Center solutions, Electronic Security surveillance, Building Management Solutions, Audio and Video solutions, Artificial Intelligence, and IoT.",
    expertiseCerts = "Certifications: CDCP, CDCS, CDCE",
    expertiseBrand = "ISO 9001-2015"
}: CtlOverviewBlockProps) {
    return (
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#F8FAF8] border-b border-[#EAEAEA] text-[#444] font-sans antialiased w-full">
            <div className="container mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-stretch">
                    
                    {/* Section Tag */}
                    <div className="lg:col-span-3 flex flex-col justify-between">
                        <div>
                            {tag && (
                                <span className="text-xs font-mono text-[#44AA52] tracking-widest block mb-2 uppercase font-semibold">
                                    {tag}
                                </span>
                            )}
                            {title && (
                                <h2 className="text-3xl font-light text-[#1A1A1A] leading-tight">
                                    {title}
                                </h2>
                            )}
                        </div>
                        {sublabel && (
                            <div className="hidden lg:block font-mono text-[10px] text-zinc-400">
                                {sublabel}
                            </div>
                        )}
                    </div>

                    {/* Intention Card */}
                    <div className="lg:col-span-4 bg-white border border-[#E5ECE5] rounded-2xl p-8 flex flex-col justify-between space-y-6 shadow-sm">
                        <div>
                            {intentionTag && (
                                <span className="text-[10px] font-mono text-[#44AA52] uppercase tracking-widest font-semibold">
                                    {intentionTag}
                                </span>
                            )}
                            {intentionText && (
                                <p className="text-zinc-650 text-sm leading-relaxed font-light mt-4">
                                    {intentionText}
                                </p>
                            )}
                        </div>
                        <div className="h-[1px] bg-[#EAEAEA]" />
                        {intentionCommit && (
                            <div className="text-[10px] font-mono text-zinc-450">
                                {intentionCommit}
                            </div>
                        )}
                    </div>

                    {/* Capability Card */}
                    <div className="lg:col-span-5 bg-white border border-[#E5ECE5] rounded-2xl p-8 flex flex-col justify-between space-y-6 relative overflow-hidden shadow-sm">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-[#44aa52]/3 rounded-full blur-2xl pointer-events-none" />
                        
                        <div>
                            {expertiseTag && (
                                <span className="text-[10px] font-mono text-[#44AA52] uppercase tracking-widest font-semibold">
                                    {expertiseTag}
                                </span>
                            )}
                            {expertiseText && (
                                <p className="text-zinc-650 text-sm leading-relaxed font-light mt-4">
                                    {expertiseText}
                                </p>
                            )}
                        </div>
                        <div className="h-[1px] bg-[#EAEAEA]" />
                        <div className="text-[10px] font-mono text-zinc-450 flex justify-between">
                            {expertiseCerts && <span>{expertiseCerts}</span>}
                            {expertiseBrand && <span className="text-[#44AA52] font-semibold">{expertiseBrand}</span>}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}
